import SpriteSymbol from "../../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-layout-left-line",
  "use": "icon-layout-left-line-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-layout-left-line\">\n    <g>\n        <path fill=\"none\" d=\"M0 0h24v24H0z\" />\n        <path fill-rule=\"nonzero\" d=\"M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18zM7 5H4v14h3V5zm13 0H9v14h11V5z\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol